import { render, staticRenderFns } from "./SwapContainer.vue?vue&type=template&id=18ccc42c&scoped=true&"
import script from "./SwapContainer.vue?vue&type=script&lang=js&"
export * from "./SwapContainer.vue?vue&type=script&lang=js&"
import style0 from "./SwapContainer.vue?vue&type=style&index=0&id=18ccc42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ccc42c",
  null
  
)

export default component.exports